import { graphql } from "@/gql";

export const createProDriverAgreement = graphql(`
  mutation CreateProDriverAgreementMutation(
    $input: CreateProDriverAgreementInput!
  ) {
    createProDriverAgreement(input: $input) {
      id
      title
      body
      status
    }
  }
`);

export const updateProDriverAgreement = graphql(`
  mutation UpdateProDriverAgreementMutation(
    $id: ID!
    $input: UpdateProDriverAgreementInput!
  ) {
    updateProDriverAgreement(id: $id, input: $input) {
      id
      title
      body
      status
    }
  }
`);

export const sendProDriverAgreement = graphql(`
  mutation SendProDriverAgreementMutation($id: ID!) {
    sendProDriverAgreement(id: $id) {
      id
      status
      sent_at
    }
  }
`);

export const voidProDriverAgreement = graphql(`
  mutation VoidProDriverAgreementMutation($id: ID!) {
    voidProDriverAgreement(id: $id) {
      id
      status
      voided_at
    }
  }
`);

export const deleteProDriverAgreement = graphql(`
  mutation DeleteProDriverAgreementMutation($id: ID!) {
    deleteProDriverAgreement(id: $id) {
      id
    }
  }
`);
